export default function PageNotFound(props) {
  const { wrapperClasses } = props

  return (
    <div className={`${wrapperClasses} text-center`}>
      <h1 className="mb-5">Sorry!</h1>
      <h2>This page doesn't exist or You don’t have permission to access it.</h2>
    </div>
  )
}